import { gql, useQuery } from '@apollo/client';
import {
  LocationPage_GetDeletePrintIssueInformationQuery,
  LocationPage_GetDeletePrintIssueInformationQueryVariables,
} from '../../../../__generated__/queries-topic';

const GET_DELETE_PRINT_ISSUE_INFORMATION = gql`
  query LocationPage_GetDeletePrintIssueInformation($id: UUID!) {
    printIssue(where: { id: $id }) {
      id
      assignmentCount
      title
      printHeadingCount(where: { assignmentCount_gt: 0 })
      printPublication {
        id
        title
      }
    }
  }
`;

export const useGetDeletePrintIssueInformation = (
  variables: LocationPage_GetDeletePrintIssueInformationQueryVariables,
) =>
  useQuery<
    LocationPage_GetDeletePrintIssueInformationQuery,
    LocationPage_GetDeletePrintIssueInformationQueryVariables
  >(GET_DELETE_PRINT_ISSUE_INFORMATION, { variables, skip: !variables.id });
